export enum Status {
  ACTIVE = 'Active',
  SCHEDULED = 'Scheduled',
  INACTIVE = 'Inactive'
}

export enum Type {
  GENERIC = 'generic',
  DMS = 'dms',
  CREDIT_LIMIT = 'creditLimit',
  SMARTCOVER = 'smartcover',
  GRADE = 'grade',
  NDCOVER = 'ndCover',
  POLICIES = 'policies',
  USER_RIGHTS = 'userRights',
  COMPANY_SEARCH = 'companySearch',
  COVER_HISTORYV2 = 'coverHistoryV2',
  GENERAL_LATENCY = 'generalLatency',
  SUPPORT_TICKETS = 'supportTickets',
  UPCOMING_MAINTENANCE = 'upcomingMaintenance'
}

export enum PossibleType {
  GENERIC = 'generic',
  DMS = 'dms',
  CREDIT_LIMIT = 'creditLimit',
  SMARTCOVER = 'smartcover',
  GRADE = 'grade',
  NDCOVER = 'ndCover',
  POLICIES = 'policies',
  USER_RIGHTS = 'userRights',
  COMPANY_SEARCH = 'companySearch',
  COVER_HISTORYV2 = 'coverHistoryV2',
  GENERAL_LATENCY = 'generalLatency',
  SUPPORT_TICKETS = 'supportTickets',
  UPCOMING_MAINTENANCE = 'upcomingMaintenance',
  BONDS = 'bonds',
  DOC_UPLOAD = 'docUpload',
  VALIDATION_PROCESS = 'validationProcess',
  BOND_SUBMISSION = 'bondSubmission',
  CONTRACTS = 'contracts',
  DOC_CONSULTING = 'docConsulting',
  RELEASE_LETTER = 'releaseLetter'
}

export enum Lob {
  SURETY = 'surety',
  TCI = 'tci',
  MIDTERM = 'midterm',
  GLOBAL = 'global'
}

export function getMessageFromType(type: Type | NewType | PossibleType): string {
  switch (type) {
    case NewType.SURETY_GENERIC:
    case NewType.TCI_GENERIC:
    case NewType.MIDTERM_GENERIC:
    case Type.GENERIC:
      return 'The current situation might prevent you from correctly accessing your information. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case NewType.GLOBAL_USER_RIGHTS:
    case Type.USER_RIGHTS:
      return 'The current situation might prevent you from correctly accessing your different services. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case NewType.SURETY_COMPANY_SEARCH:
    case NewType.TCI_COMPANY_SEARCH:
    case Type.COMPANY_SEARCH:
      return 'The current situation might prevent you from correctly accessing the customer search. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case NewType.GLOBAL_GENERAL_LATENCY:
    case Type.GENERAL_LATENCY:
      return "You may experience some issues with the application's performance. Our teams are currently working to improve the speed and stability of the service. Thank you for your patience and understanding."
    case NewType.TCI_DMS:
    case Type.DMS:
      return 'The current situation might prevent you from correctly accessing your most up to date information. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case NewType.TCI_CREDIT_LIMIT:
    case NewType.MIDTERM_CREDIT_LIMIT:
    case Type.CREDIT_LIMIT:
      return 'The current situation might prevent you from correctly accessing your credit limit services. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case NewType.TCI_SMARTCOVER:
    case Type.SMARTCOVER:
      return 'The current situation might prevent you from correctly accessing your CIO services. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case NewType.TCI_GRADE:
    case Type.GRADE:
      return 'The current situation might prevent you from correctly accessing your grade services. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case NewType.TCI_NDCOVER:
    case Type.NDCOVER:
      return 'The current situation might prevent you from correctly accessing your ND cover services. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case NewType.TCI_POLICIES:
    case NewType.MIDTERM_POLICIES:
    case Type.POLICIES:
      return 'The current situation might prevent you from correctly accessing your policy portfolio. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case NewType.TCI_COVER_HISTORYV2:
    case NewType.MIDTERM_COVER_HISTORYV2:
    case Type.COVER_HISTORYV2:
      return 'The current situation might prevent you from correctly accessing history information. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case NewType.TCI_SUPPORT_TICKETS:
    case NewType.MIDTERM_SUPPORT_TICKETS:
    case Type.SUPPORT_TICKETS:
      return 'The current situation might prevent you from correctly creating support requests. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case Type.UPCOMING_MAINTENANCE:
    case NewType.TCI_UPCOMING_MAINTENANCE:
    case NewType.SURETY_UPCOMING_MAINTENANCE:
    case NewType.GLOBAL_UPCOMING_MAINTENANCE:
    case NewType.MIDTERM_UPCOMING_MAINTENANCE:
      return 'Due to maintenance works planned for the upcoming weekend, your access to Allianz Trade Online might be disrupted during this period of time.'
    case NewType.SURETY_BONDS:
    case PossibleType.BONDS:
      return 'The current situation might prevent you from correctly accessing your bond list. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case NewType.SURETY_DOC_UPLOAD:
    case PossibleType.DOC_UPLOAD:
      return 'The current situation might prevent you from uploading documents with your requests. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case NewType.SURETY_VALIDATION_PROCESS:
    case PossibleType.VALIDATION_PROCESS:
      return 'The current situation might prevent you from correctly accessing your bond request list. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case NewType.SURETY_BOND_SUBMISSION:
    case PossibleType.BOND_SUBMISSION:
      return 'The current situation might prevent you from conducting bond requests. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case NewType.SURETY_CONTRACTS:
    case PossibleType.CONTRACTS:
      return 'The current situation might prevent you from correctly accessing your contract list. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case NewType.SURETY_DOC_CONSULTING:
    case PossibleType.DOC_CONSULTING:
      return 'The current situation might prevent you from correctly accessing your document list and generating. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    case NewType.SURETY_RELEASE_LETTER:
    case PossibleType.RELEASE_LETTER:
      return 'The current situation might prevent you from correctly  generating documents. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
    default:
      return 'The current situation might prevent you from correctly accessing your information. Our teams are dedicated to the resolution of the issue as soon as possible. Thank you for your understanding.'
  }
}

export enum GlobalType {
  GENERIC = 'generic',
  USER_RIGHTS = 'userRights',
  GENERAL_LATENCY = 'generalLatency',
  UPCOMING_MAINTENANCE = 'upcomingMaintenance'
}

export enum TciType {
  GENERIC = 'generic',
  DMS = 'dms',
  CREDIT_LIMIT = 'creditLimit',
  SMARTCOVER = 'smartcover',
  GRADE = 'grade',
  TCI_NDCOVER = 'ndCover',
  TCI_POLICIES = 'policies',
  COMPANY_SEARCH = 'companySearch',
  TCI_COVER_HISTORYV2 = 'coverHistoryV2',
  TCI_SUPPORT_TICKETS = 'supportTickets',
  TCI_UPCOMING_MAINTENANCE = 'upcomingMaintenance'
}

export enum MidTermType {
  GENERIC = 'generic',
  CREDIT_LIMIT = 'creditLimit',
  TCI_POLICIES = 'policies',
  TCI_COVER_HISTORYV2 = 'coverHistoryV2',
  TCI_SUPPORT_TICKETS = 'supportTickets',
  TCI_UPCOMING_MAINTENANCE = 'upcomingMaintenance'
}

export enum SuretyType {
  GENERIC = 'generic',
  COMPANY_SEARCH = 'companySearch',
  UPCOMING_MAINTENANCE = 'upcomingMaintenance',
  BONDS = 'bonds',
  DOC_UPLOAD = 'docUpload',
  VALIDATION_PROCESS = 'validationProcess',
  BOND_SUBMISSION = 'bondSubmission',
  CONTRACTS = 'contracts',
  DOC_CONSULTING = 'docConsulting',
  RELEASE_LETTER = 'releaseLetter'
}

export enum NewType {
  GLOBAL_GENERIC = 'global.generic',
  GLOBAL_UPCOMING_MAINTENANCE = 'global.upcomingMaintenance',
  GLOBAL_USER_RIGHTS = 'global.userRights',
  GLOBAL_GENERAL_LATENCY = 'global.generalLatency',
  TCI_GENERIC = 'tci.generic',
  TCI_DMS = 'tci.dms',
  TCI_CREDIT_LIMIT = 'tci.creditLimit',
  TCI_SMARTCOVER = 'tci.smartcover',
  TCI_GRADE = 'tci.grade',
  TCI_NDCOVER = 'tci.ndCover',
  TCI_POLICIES = 'tci.policies',
  TCI_COVER_HISTORYV2 = 'tci.coverHistoryV2',
  TCI_SUPPORT_TICKETS = 'tci.supportTickets',
  TCI_UPCOMING_MAINTENANCE = 'tci.upcomingMaintenance',
  TCI_COMPANY_SEARCH = 'tci.companySearch',
  SURETY_UPCOMING_MAINTENANCE = 'surety.upcomingMaintenance',
  SURETY_BONDS = 'surety.bonds',
  SURETY_DOC_UPLOAD = 'surety.docUpload',
  SURETY_VALIDATION_PROCESS = 'surety.validationProcess',
  SURETY_BOND_SUBMISSION = 'surety.bondSubmission',
  SURETY_CONTRACTS = 'surety.contracts',
  SURETY_DOC_CONSULTING = 'surety.docConsulting',
  SURETY_RELEASE_LETTER = 'surety.releaseLetter',
  SURETY_GENERIC = 'surety.generic',
  SURETY_COMPANY_SEARCH = 'surety.companySearch',
  MIDTERM_GENERIC = 'midterm.generic',
  MIDTERM_UPCOMING_MAINTENANCE = 'midterm.upcomingMaintenance',
  MIDTERM_CREDIT_LIMIT = 'midterm.creditLimit',
  MIDTERM_POLICIES = 'midterm.policies',
  MIDTERM_COVER_HISTORYV2 = 'midterm.coverHistoryV2',
  MIDTERM_SUPPORT_TICKETS = 'midterm.supportTickets'
}

export function stringToLob(lob: string): Lob {
  switch (lob) {
    case Lob.SURETY:
      return Lob.SURETY
    case Lob.MIDTERM:
      return Lob.MIDTERM
    case Lob.GLOBAL:
      return Lob.GLOBAL
    default:
      return Lob.TCI
  }
}

export function stringToType(type: string): NewType | Type | PossibleType {
  switch (type) {
    case NewType.TCI_DMS:
      return NewType.TCI_DMS
    case NewType.TCI_CREDIT_LIMIT:
      return NewType.TCI_CREDIT_LIMIT
    case NewType.TCI_SMARTCOVER:
      return NewType.TCI_SMARTCOVER
    case NewType.TCI_GRADE:
      return NewType.TCI_GRADE
    case NewType.TCI_NDCOVER:
      return NewType.TCI_NDCOVER
    case NewType.TCI_POLICIES:
      return NewType.TCI_POLICIES
    case NewType.TCI_COVER_HISTORYV2:
      return NewType.TCI_COVER_HISTORYV2
    case NewType.TCI_SUPPORT_TICKETS:
      return NewType.TCI_SUPPORT_TICKETS
    case NewType.TCI_GENERIC:
      return NewType.TCI_GENERIC
    case NewType.TCI_UPCOMING_MAINTENANCE:
      return NewType.TCI_UPCOMING_MAINTENANCE
    case NewType.TCI_COMPANY_SEARCH:
      return NewType.TCI_COMPANY_SEARCH
    case NewType.SURETY_UPCOMING_MAINTENANCE:
      return NewType.SURETY_UPCOMING_MAINTENANCE
    case NewType.SURETY_BONDS:
      return NewType.SURETY_BONDS
    case NewType.SURETY_DOC_UPLOAD:
      return NewType.SURETY_DOC_UPLOAD
    case NewType.SURETY_VALIDATION_PROCESS:
      return NewType.SURETY_VALIDATION_PROCESS
    case NewType.SURETY_BOND_SUBMISSION:
      return NewType.SURETY_BOND_SUBMISSION
    case NewType.SURETY_CONTRACTS:
      return NewType.SURETY_CONTRACTS
    case NewType.SURETY_DOC_CONSULTING:
      return NewType.SURETY_DOC_CONSULTING
    case NewType.SURETY_RELEASE_LETTER:
      return NewType.SURETY_RELEASE_LETTER
    case NewType.SURETY_GENERIC:
      return NewType.SURETY_GENERIC
    case NewType.SURETY_COMPANY_SEARCH:
      return NewType.SURETY_COMPANY_SEARCH
    case NewType.GLOBAL_USER_RIGHTS:
      return NewType.GLOBAL_USER_RIGHTS
    case NewType.GLOBAL_GENERAL_LATENCY:
      return NewType.GLOBAL_GENERAL_LATENCY
    case NewType.GLOBAL_UPCOMING_MAINTENANCE:
      return NewType.GLOBAL_UPCOMING_MAINTENANCE
    case NewType.GLOBAL_GENERIC:
      return NewType.GLOBAL_GENERIC
    case NewType.MIDTERM_GENERIC:
      return NewType.MIDTERM_GENERIC
    case NewType.MIDTERM_CREDIT_LIMIT:
      return NewType.MIDTERM_CREDIT_LIMIT
    case NewType.MIDTERM_POLICIES:
      return NewType.MIDTERM_POLICIES
    case NewType.MIDTERM_COVER_HISTORYV2:
      return NewType.MIDTERM_COVER_HISTORYV2
    case NewType.MIDTERM_SUPPORT_TICKETS:
      return NewType.MIDTERM_SUPPORT_TICKETS
    case NewType.MIDTERM_UPCOMING_MAINTENANCE:
      return NewType.MIDTERM_UPCOMING_MAINTENANCE
    case Type.DMS:
      return Type.DMS
    case Type.CREDIT_LIMIT:
      return Type.CREDIT_LIMIT
    case Type.SMARTCOVER:
      return Type.SMARTCOVER
    case Type.GRADE:
      return Type.GRADE
    case Type.NDCOVER:
      return Type.NDCOVER
    case Type.POLICIES:
      return Type.POLICIES
    case Type.USER_RIGHTS:
      return Type.USER_RIGHTS
    case Type.COMPANY_SEARCH:
      return Type.COMPANY_SEARCH
    case Type.COVER_HISTORYV2:
      return Type.COVER_HISTORYV2
    case Type.GENERAL_LATENCY:
      return Type.GENERAL_LATENCY
    case Type.SUPPORT_TICKETS:
      return Type.SUPPORT_TICKETS
    case Type.UPCOMING_MAINTENANCE:
      return Type.UPCOMING_MAINTENANCE
    case Type.GENERIC:
      return Type.GENERIC
    case PossibleType.BONDS:
      return PossibleType.BONDS
    case PossibleType.DOC_UPLOAD:
      return PossibleType.DOC_UPLOAD
    case PossibleType.VALIDATION_PROCESS:
      return PossibleType.VALIDATION_PROCESS
    case PossibleType.BOND_SUBMISSION:
      return PossibleType.BOND_SUBMISSION
    case PossibleType.CONTRACTS:
      return PossibleType.CONTRACTS
    case PossibleType.DOC_CONSULTING:
      return PossibleType.DOC_CONSULTING
    case PossibleType.RELEASE_LETTER:
      return PossibleType.RELEASE_LETTER
    case PossibleType.COMPANY_SEARCH:
      return PossibleType.COMPANY_SEARCH
    default:
      return Type.GENERIC
  }
}

interface Message {
  applicationId: string
  id: string
  type: Type | NewType | PossibleType
  lob?: Lob
  message: string
  startDateTime: Date
  endDateTime?: Date
  status: Status
  hasFallback?: boolean
  buCode?: string
}

export interface EditableMessage {
  id: string
  type: string
  startDateTime: Date
  endDateTime?: Date
}

export default Message
